import { dataBarChartSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBarChartSolid = /*#__PURE__*/createIcon(dataBarChartSolid)
export default IconBarChartSolid
